const recipeMenuItemStatus = 1
const recipeBankItemStatus = 2
const recipeTestItemStatus = 3

export {
  recipeMenuItemStatus,
  recipeBankItemStatus,
  recipeTestItemStatus
}